import axios from 'axios';

export function getNotes(note_id) {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/observations/${note_id}`)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function putNotes(note_id) {
    return new Promise((resolve, reject) => {
        axios
            .put(`/api/observations/${note_id}`)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                console.error(
                    'No se pudo modificar la informacion del paciente',
                );
                reject(error);
            });
    });
}

export async function postNotes(data) {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/observations`, data)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                console.error('Error en la solicitud:', error);
                reject(error);
            });
    });
}

export async function postDiagnostico(data) {
    return new Promise((resolve, reject) => {
        axios
            .post(`/api/recetas/appointment`, data)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                console.error('Error en la solicitud:', error);
                reject(error);
            });
    });
}

export async function putDiagnostico(diagnosisId, data) {
    return new Promise((resolve, reject) => {
        axios
            .put(`/api/recetas/appointment/${diagnosisId}`, data)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                console.error('Error en la solicitud:', error);
                reject(error);
            });
    });
}

export async function getAppointment(patientId) {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/recetas/appointment/${patientId}`)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.error('Error en la solicitud:', error);
                reject(error);
            });
    });
}

export async function getAppointmentsByPractitionerId(patientId, practitionerId){
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/recetas/appointment/patient/${patientId}/practitioner/${practitionerId}`)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.error('Error en la solicitud:', error);
                reject(error);
            });
    });
}

export async function getFinalNote(prescriptionId) {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/recetas/note/${prescriptionId}`)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.error('Error en la solicitud:', error);
                reject(error);
            });
    });
}
